module.exports = __webpack_public_path__ + "static/media/025.56b2948f.jpg";